import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import CenterOpdComparisonReport from "../components/CenterOpdComparisonReport";
const TreatmentRevenueOverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout >

        {/* Breadcrumb */}
        <Breadcrumb title="Centers Opd Comparison" />

        <CenterOpdComparisonReport />

      </MasterLayout>
    </>
  );
};

export default TreatmentRevenueOverviewPage;
